module.exports = __webpack_public_path__ + "assets/img/14_895.e43f0292.jpg";